<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} and exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="country-code" class="form-label">Code *</label>
              <input type="text" class="form-control" id="country-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="country-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="country-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="world-area" class="form-label">World area</label>
              <select class="form-control" id="world-area" v-model="entity.worldArea">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('WORLD_AREA')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="acc-code" class="form-label">Accounts code</label>
              <input type="text" class="form-control" id="acc-code" v-model="entity.accountsCode"/>
            </div>
            <div class="form-group">
              <label for="ext-code" class="form-label">External ID</label>
              <input type="number" step="1" class="form-control" id="ext-code" v-model="entity.externalId">
            </div>
            <div class="form-group">
              <label for="ins-area" class="form-label">Insurance Zone</label>
              <select class="form-control" id="ins-area" v-model="entity.insuranceZone">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('INSURANCE_AREA')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="country-cur" class="form-label">Currency</label>
              <select class="form-control" id="country-cur" v-model="entity.currency">
                <option value=""></option>
                <option v-for="(opt, i) in currencies" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <!--
              <div class="form-group">
                <label for="continent" class="form-label">Continent</label>
                <auto-complete
                  :dataset="continentSearchResults"
                  :placeHolder="'Type to search'"
                  :initVal="entity.continent"
                  v-on:changing="data => continentSearchText = data"
                  :fnFormatText="p => `ID: ${p.id}, NAME: ${p.name}`"
                  :fnSelectValue="p => `ID: ${p.id}, NAME: ${p.name}`"
                  v-on:selection-made="c => entity.continent = c"
                ></auto-complete>
              </div>
            -->
            <div class="form-group">
              <label for="lat" class="form-label">Latitude</label>
              <input type="number" step="0.0000001" class="form-control" id="lat" v-model="entity.latitude"/>
            </div>
            <div class="form-group">
              <label for="lat" class="form-label">Longitude</label>
              <input type="number" step="0.0000001" class="form-control" id="lat" v-model="entity.longitude"/>
            </div>
            <div class="form-group">
              <label for="lngs" class="form-label">Languages Spoken</label>
              <input type="text" class="form-control" id="lngs" v-model="entity.languagesSpoken"/>
            </div>
            <div class="form-group">
              <label for="def" class="form-label">Default Max. Town Distance</label>
              <input type="number" step="0.01" class="form-control" id="def" v-model="entity.defaultMaxTownDistance"/>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <label for="country-comments" class="form-label">Comments</label>
              <textarea class="form-control" rows="5" id="country-comments" v-model="entity.notes"></textarea>
            </div>
            <div class="form-group">
              <label for="country-comments-ex" class="form-label">Comments (extra)</label>
              <textarea class="form-control" rows="5" id="country-comments-ex" v-model="entity.extraNotes"></textarea>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import API from '../../../../api/endpoints.js'
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import AutoComplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'Country',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {
      AutoComplete
    },
    data () {
      return {
        shouldUpdateCache: true,
        cachePropertyName: 'countries',
        transformForUpdate: {
          continent: this.toMinus,
          insuranceZone: this.toMinus,
          currency: this.toMinus,
          worldArea: this.toMinus,
          externalId: this.toZero,
          defaultMaxTownDistance: this.toZero
        },
        newEntityScreen: 'Admin - Countries',
        editEntityScreen: 'Admin - Edit/View Country',
        tab: 'main',
        boxes: [{ prop: 'worldArea', id: 'id' }, { prop: 'currency', id: 'id' }, { prop: 'insuranceZone', id: 'id' }],
        entity: {
          id: null,
          code: null,
          name: null,
          accountsCode: null,
          continent: null,
          insuranceZone: null,
          currency: null,
          worldArea: null,
          latitude: null,
          longitude: null,
          notes: null,
          extraNotes: null,
          externalId: null,
          languagesSpoken: null,
          defaultMaxTownDistance: null
        },
        entityName: 'country',
        continentSearchResults: [],
        continentSearchText: ''
      }
    },
    computed: {
      isValid () {
        return this.entity.code && this.entity.name &&
        this.entity.code.trim().length > 0 &&
        this.entity.name.trim().length > 0
      }
    },
    watch: {
      continentSearchText (newVal, oldVal) {
        if (newVal.trim().length > 1) {
          this.updateContinentSearchResults(newVal)
        } else {
          this.continentSearchResults = []
        }
      }
    },
    methods: {
      updateContinentSearchResults (str) {
        this.$http.get(API.GET_LOCATIONS_NAME_LIKE(str))
          .then(({data}) => {
            if (str === this.locationSearch) {
              this.$store.dispatch('quote/mapLocationsWithCountry', data)
              .then(res => {
                this.continentSearchResults = res
              })
              .catch(err => {
                console.log(err)
                this.continentSearchResults = data
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      getBaseData () {
        return {
          id: null,
          code: null,
          name: null,
          accountsCode: null,
          continent: null,
          insuranceZone: null,
          currency: null,
          worldArea: null,
          latitude: null,
          longitude: null,
          notes: null,
          extraNotes: null,
          externalId: null,
          languagesSpoken: null,
          defaultMaxTownDistance: null
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Country/Country.vue